import React, { lazy, Suspense } from 'react';

const LazyVanHanh = lazy(() => import('./VanHanh'));

const VanHanh = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyVanHanh {...props} />
  </Suspense>
);

export default VanHanh;
